module.exports = __webpack_public_path__ + "static/pyxis_of_pandemonium-dac7e2c915eeff7187432dc9fc6adb4a.jpg";